import Vue from 'vue'
import router from './router'
import App from './App.vue'



import 'expose-loader?$!expose-loader?jQuery!jquery'
	   

import {MdToolbar, MdButton,MdCheckbox, MdRadio, MdField, MdSwitch, MdProgress} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(MdToolbar)
Vue.use(MdButton)
Vue.use(MdCheckbox)
Vue.use(MdRadio)
Vue.use(MdField)
Vue.use(MdSwitch)
Vue.use(MdProgress)

import Vuex from 'vuex'
import 'es6-promise/auto'

Vue.use(Vuex)

import form from './common/form'
import util from './common/util'

Vue.prototype.$VARS = {
	url:'https://poolda.ai/',
	callBack:'returnScript',
	devToken:'sadjovciaJDJAOISDJKJA',
	debug:false,
	app:'app' // app,server
}


Vue.config.productionTip = false


import 'chart.js'
import 'hchs-vue-charts'
Vue.use(window.VueCharts)

Storage.prototype.setObject = function(key, value) {
        this.setItem(key, JSON.stringify(value));
}
    
Storage.prototype.getObject = function(key) {
      return JSON.parse(this.getItem(key));
}

const store = new Vuex.Store({
	state: {
		historyInfo: {
			pageHistory:[],
			back:false
		},
		mainDatas: {
			mainBanners:[],
		},
		
			
	},
	getters: {
		getHistoryInfo: state=> {
			return state.historyInfo;
		},
		
		
	},
	mutations: {
        updateMainWords(state,params) {
			state.mainWords = params;

		},
		
	},
	modules: {
	
	}

})

Vue.prototype.$form = form;
Vue.prototype.$util = util;


var EventBus = new Vue();
Object.defineProperties(Vue.prototype, {
	$eventBus: {
		get: function () {
			return EventBus;
		}
	}
});


var vue = new Vue({
  store,
  created: function () {
	   this.$form.initalize(this);
	
  },
  methods: {
		
  },
  router,
  render: h => h(App)
}).$mount('#app')

